import '../Styles/GroupAccountDashboard.scss';
import GroupReservationCard from './GroupReservationCard.js';
import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import Session from 'react-session-api';
import { useNavigate } from 'react-router-dom';

const GroupAccountDashboard = () => {

   const [registrations, setRegistrations] = useState()
   const [registrationsLoaded, setRegistrationsLoaded] = useState(false)
   const [email, setEmail] = useState()
   const [names, setGroupNames] = useState({
      churchName: '',
      churchAdmin: '',
      churchCode: ''
   });
   const [floatingButtonVisible, setFloatingButtonVisible] = useState(false)
   const inlineReservationButton = useRef(null)
   const navigate = useNavigate()

   const getCurrentUser = async () => {
      const groupAccountResponse = await fetch('/api/get-user', {
         method: 'GET',
         headers: { "Content-Type": "application/json" }
      })

      if (groupAccountResponse.status === 400 || groupAccountResponse.status === 401 || groupAccountResponse.status === 500) {
         Session.set("isAuth", null)
         Session.set("accountType", null)
         navigate('/')
         throw new Error("Failed User Retrieval");
      }

      const account = await groupAccountResponse.json();

      const groupRegistrations = await fetch('/getgroupreservations', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
            email: account.account.group_email,
            id: account.account.group_account_id,
         })
      })
      const registrations = await groupRegistrations.json();
      setRegistrations(registrations.data.groupRegistrations)
      setRegistrationsLoaded(true)
      setEmail(account.email)
      setGroupNames({
         churchName: registrations.data.groupNames[0].group_name,
         churchAdmin: registrations.data.groupNames[0].church_group_admin,
         churchCode: registrations.data.groupNames[0].group_id
      })
   }

   useEffect(() => {
      getCurrentUser()
   }, []);

   // The floating button is a fallback for the real one at the bottom of the panel: a group with
   // enough reservations to scroll would otherwise have no visible way to add another. It appears
   // only once the real button has left the viewport entirely, so the two are never on screen at
   // the same time and it never covers a card the user could already act on.
   useEffect(() => {
      const inlineButton = inlineReservationButton.current
      if (!inlineButton || typeof IntersectionObserver === 'undefined') {
         return
      }
      const observer = new IntersectionObserver(([entry]) => {
         setFloatingButtonVisible(entry.isIntersecting === false)
      })
      observer.observe(inlineButton)
      return () => observer.disconnect()
   }, []);

   const hasReservations = Array.isArray(registrations) && registrations.length > 0

   return (
      <div>
         <div className="groupAccountContent">
            <div className="groupAccountContainer">
               <div className="groupHeading">
                  <h>Welcome, {names.churchName}</h>
               </div>
               <div className="groupAccountRegistrations">
                  <div className="groupAccountRegistrationsHeading">
                     <h>Reservations</h>
                  </div>
                  <div className="groupAccountReservationsList">
                     {hasReservations &&
                        registrations.map((reservation) => (
                           <GroupReservationCard
                              key={reservation.reservation_id}
                              reservation={reservation} />
                        ))
                     }
                     {/* Held back until the query resolves so the empty state doesn't flash on load. */}
                     {registrationsLoaded === true && hasReservations === false &&
                        <div className="groupAccountNoReservationsMessage">
                           You do not have any current reservations. Make a reservation to see it here!
                        </div>
                     }
                  </div>
               </div>
               <div className="groupRegistrationButton" ref={inlineReservationButton}>
                  <Link to={'/groupreservation'}>
                     <button>
                        Make a New Reservation
                     </button>
                  </Link>
               </div>
               <div className="groupRegistrationGroupCodeExplanation">
                  <div className="groupRegistrationGroupCodeExplanationLine1">
                     * Copy your registration's group code and send it to all campers planning to join for your selected week.
                  </div>
               </div>
            </div>
         </div>
         {floatingButtonVisible === true &&
            <div className="groupRegistrationFloatingButton">
               <Link to={'/groupreservation'}>
                  <button>
                     Make a New Reservation
                  </button>
               </Link>
            </div>
         }
      </div>
   )
}
export default GroupAccountDashboard;
